import { useState } from "react"
import AttachmentsSidebar from "../components/attachments/AttachmentsSidebar"
import LargeFolderIcon from "../components/attachments/LargeFolderIcon"
import { useAttachmentsInFolder } from "../components/attachments/attachmentsQueries"
import AttachmentsViewer from "../components/attachments/AttachmentsViewer"
import { escapeFolderId } from "../components/attachments/attachmentsModel"

type Props = {
  customerId: number
  propertyId?: number
  jobId?: number
  initialFolder?: string
  backUrl: string
}

type SelectedFolder = {
  id?: string
  jobId?: number
}

const AttachmentsPage = ({customerId, propertyId, jobId, initialFolder, backUrl}: Props) => {
  const [selectedFolder, setSelectedFolder] = useState<SelectedFolder | undefined>(undefined)
  const attachmentsQuery = useAttachmentsInFolder(escapeFolderId(selectedFolder?.id), customerId, propertyId, selectedFolder?.jobId)

  const attachments = attachmentsQuery.data ?? []
  
  const pageContent = () => {
    if (attachments.length > 0) {
      return <AttachmentsViewer
        attachments={attachments}
        showFolders={selectedFolder?.id === '__All'}
        customerId={customerId}
        propertyId={propertyId}
      />
    }

    let text = "SELECT A FOLDER"
    if (selectedFolder?.id !== undefined ) {
      if (attachments.length === 0) {
        text = "THIS FOLDER IS EMPTY"
      }
      if (attachmentsQuery.isLoading) {
        text = "LOADING..."
      }
    }
    return <LargeFolderIcon text={text} />
  }

  const handleFolderSelect = (folderId: string | undefined, jobId?: number) => {
    setSelectedFolder({ id: folderId, jobId })
  }

  return <>
    <AttachmentsSidebar
      selectedFolderId={selectedFolder?.id}
      customerId={customerId}
      propertyId={propertyId}
      jobId={jobId}
      onFolderSelect={handleFolderSelect}
      initialFolder={initialFolder}
      backUrl={backUrl}
    />
    <div id="main" className="main-attachments has-elements fluid-container">
      {pageContent()}
    </div>
  </>
}

export default AttachmentsPage
